<template>
    <div class="selectNumBox">
        <div class="del" @click="delBtn">
            <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
        </div>
        <div class="numInput">{{ selectNum }}</div>
        <div class="add" @click="addBtn">
            <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectNum',
    props: ['selectNum'],
    data() {
        return {}
    },
    mounted() {},
    methods: {
        delBtn() {
            if (this.selectNum == 0) {
                return
            }
            this.$emit('update:selectNum', Number(this.selectNum) - 1)
        },
        addBtn() {
            if (this.selectNum == 99) {
                return
            }
            this.$emit('update:selectNum', Number(this.selectNum) + 1)
        },
    },
}
</script>

<style lang="less" scoped>
.selectNumBox {
    width: 80px;
    height: 24px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #d5d8de;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .del {
        flex: 1;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-right: 1px solid #d5d8de;

        .jianIcon {
            width: 10px;
            height: 10px;
        }
    }

    .numInput {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
    }

    .add {
        flex: 1;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-left: 1px solid #d5d8de;

        .jiaIcon {
            width: 10px;
            height: 10px;
        }
    }
}
</style>
